import { Component, Input } from '@angular/core';

import { MyModal } from './../../../../../common/my-modal/my-modal.component';
import { HtmlService } from './../../../../../../services/html.service';

@Component({
    selector: 'ipp-transcript',
    template: require('./ipp-transcript.component.html')
})
export class IppTranscriptComponent {
    @Input() title: string;
    @Input() resourceId: number;

    constructor(
        private myModal: MyModal,
        private htmlService: HtmlService
    ) {

    }

    showDialog() {
        this.htmlService.getResourceTranscript(this.resourceId).subscribe(resourceDto => {
            this.myModal.showRegularDlg(this.title, `<div class="transcript-modal">${resourceDto.Transcript}</div>`, [
                { label: "Close", style: "btn-primary" }
            ]);
        });        
    }
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-transcript/ipp-transcript.component.ts